import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

// Query keys
const NATIONALITIES_QUERY_KEY = 'nationalities';

// Custom hook for fetching nationalities
export const useNationalities = (page = 1, limit = 10) => {
  return useQuery({
    queryKey: [NATIONALITIES_QUERY_KEY, page, limit],
    queryFn: () => apiClient.nationalities.getAll(page, limit),
    keepPreviousData: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

// Custom hook for creating a nationality
export const useCreateNationality = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (nationalityData) => apiClient.nationalities.create(nationalityData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NATIONALITIES_QUERY_KEY] });
    },
  });
};

// Custom hook for updating a nationality
export const useUpdateNationality = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, nationalityData }) => apiClient.nationalities.update(id, nationalityData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NATIONALITIES_QUERY_KEY] });
    },
  });
};

// Custom hook for deleting a nationality
export const useDeleteNationality = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => apiClient.nationalities.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NATIONALITIES_QUERY_KEY] });
    },
  });
};

// Custom hook for getting a single nationality
export const useNationality = (id) => {
  return useQuery({
    queryKey: [NATIONALITIES_QUERY_KEY, id],
    queryFn: () => apiClient.nationalities.getById(id),
    enabled: !!id,
  });
}; 